module.exports = __webpack_public_path__ + "static/media/rv.a9d2cc77.svg";